import React, { useState, useEffect } from "react";
import {
    StyledAccordionIcon,
    StyledAccordionItems,
} from "styles/components/Accordion.styles";
import Paper from "mrf/view/Paper";
import { Grid } from "mrf/view/Grid";
import { StyledCell, StyledHeader, StyledRow, StyledTable } from "styles/components/Table.styles";
import useMRFTranslation from "mrf/utils/useMRFTranslation";
import Flex from "mrf/layout/Flex";
import { useRef } from "react";
import Button from "mrf/view/Button";
import If from "mrf/utils/If";

function AccordionRow({ rowContent, rowContentFields, accordionContentFields, accordionContents, displayAccordionTooltip }) {
    const t = useMRFTranslation();

    const [active, setActive] = useState(false);
    const contentRef = useRef(null);

    useEffect(() => {
        contentRef.current.style.maxHeight = active
            ? `${contentRef.current.scrollHeight}px`
            : "0px";
    }, [contentRef, active]);

    const toggleActive = () => {
        setActive(!active);
    };

    return <>
        <StyledRow>
            {rowContentFields?.map((field) => {
                const fieldContent = field?.key
                    ? rowContent[field?.key]
                    : field?.keys
                        ? field?.keys.reduce((obj, key) => obj?.[key], rowContent)
                        : '';

                return <StyledCell>
                    {field.map
                        ? field.map(fieldContent)
                        : fieldContent}
                    </StyledCell>

            })}
                <StyledCell>
                <If condition={accordionContents?.length > 0}>
                    <Flex className="justify-center">
                        <Button onClick={toggleActive} tooltip={displayAccordionTooltip} >
                            <StyledAccordionIcon active={active} />
                        </Button>
                    </Flex>
                </If>
                </StyledCell>
        </StyledRow>

        {accordionContents && <>
            <tr style={{ display: "none" }} />
            <StyledRow style={{ display: active ? "table-row" : "none" }}>
                <StyledCell colSpan={rowContentFields?.length + 1}>
                    <StyledAccordionItems ref={contentRef}>
                        <Paper className='mb-2 border border-gray-300'>
                            <Grid cols={1}>
                                <StyledTable>
                                    <thead>
                                        <StyledRow>
                                            {accordionContentFields?.map((field) => (
                                                <StyledHeader>
                                                    {t(field.name)}
                                                </StyledHeader>
                                            ))}
                                        </StyledRow>
                                    </thead>
                                    <tbody>
                                        {accordionContents?.map(content => 
                                            <StyledRow>
                                                {accordionContentFields?.map((field) => {
                                                    const fieldContent = field?.key
                                                        ? content[field?.key]
                                                        : field?.keys
                                                        ? field?.keys.reduce((obj, key) => obj?.[key], content)
                                                        : '';

                                                    return <StyledCell>
                                                        {field.map
                                                            ? field.map(fieldContent)
                                                            : fieldContent}
                                                        </StyledCell>
                                                })}
                                            </StyledRow>
                                        )}
                                    </tbody>
                                </StyledTable>
                            </Grid>
                        </Paper>
                    </StyledAccordionItems>
                </StyledCell>
            </StyledRow>
        </>}
    </>
}

export default AccordionRow;